import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { AlertSeverity } from "@/types/edr";

const SEV_STYLES: Record<AlertSeverity, string> = {
  critical: "bg-destructive/15 text-destructive border-destructive/30",
  high: "bg-warning-muted text-warning-muted-foreground border-warning/30",
  medium: "bg-info-muted text-info-muted-foreground border-info/30",
  low: "bg-muted text-muted-foreground border-border",
  info: "bg-muted text-muted-foreground border-border",
};

interface SeverityBadgeProps {
  severity: AlertSeverity;
  className?: string;
}

export function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn("uppercase text-[10px] tracking-wider", SEV_STYLES[severity], className)}
    >
      {severity}
    </Badge>
  );
}
